
// // src/components/layout/Sidebar.jsx
// import React, { useState } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../../contexts/AuthContext';
// import { useNotification } from '../../contexts/NotificationContext';

// const Sidebar = ({ isMobile = false, onClose }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { vendorProfile } = useAuth();
//   const { unreadCount } = useNotification();
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   // Check if vendor has order management enabled
//   const hasOrderManagement = vendorProfile?.businessType !== 'without-orders';

//   // Navigation items
//   const navigationItems = [
//     {
//       name: 'Dashboard',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
//         </svg>
//       ),
//       path: '/dashboard',
//     },
//     {
//       name: 'Inventory',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
//         </svg>
//       ),
//       path: '/inventory',
//     },
//     // Only show Orders if order management is enabled
//     ...(hasOrderManagement ? [{
//       name: 'Orders',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
//         </svg>
//       ),
//       path: '/orders',
//     }] : []),
//     ...(hasOrderManagement ? [{
//       name: 'Communication',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
//         </svg>
//       ),
//       path: '/communication',
//     }] : []),
//     ...(hasOrderManagement ? [{
//       name: 'Notifications',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
//         </svg>
//       ),
//       path: '/notifications',
//       badge: unreadCount > 0 ? unreadCount : null,
//     }] : []),
//     ...(hasOrderManagement ? [{
//       name: 'Porter',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//         </svg>
//       ),
//       path: '/porter',
//     }] : []),
   
//     {
//       name: 'Billing',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
//         </svg>
//       ),
//       path: '/billing',
//     },
//     {
//       name: 'Create Invoice',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//         </svg>
//       ),
//       path: '/billing/create',
//     },
//     {
//       name: 'Billing Reports',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//         </svg>
//       ),
//       path: '/billing/reports',
//     },
//     // Return Policy - Available for all vendors
//     {
//       name: 'Returns',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
//         </svg>
//       ),
//       path: '/returns',
//     },
//      // Customers Management - Available for all vendors
//     {
//       name: 'Customers',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
//         </svg>
//       ),
//       path: '/customers',
//     },
//     // Suppliers Management - Available for all vendors
//     {
//       name: 'Suppliers',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
//         </svg>
//       ),
//       path: '/suppliers',
//     },
//     {
//       name: 'Profile',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//         </svg>
//       ),
//       path: '/profile',
//     },
//     {
//       name: 'Help',
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//         </svg>
//       ),
//       path: '/help',
//     },
//   ];

//   // Check if a link is active
//   const isActive = (path) => {
//     // Special handling for billing routes
//     if (path === '/billing') {
//       return location.pathname === '/billing';
//     }
//     if (path === '/billing/create') {
//       return location.pathname === '/billing/create';
//     }
//     // For other routes, use exact match or startsWith for sub-routes
//     return location.pathname === path || (location.pathname.startsWith(path + '/') && path !== '/billing');
//   };

//   // Handle create invoice navigation
//   const handleCreateInvoice = () => {
//     navigate('/billing/create?type=sales');
//     if (isMobile && onClose) {
//       onClose();
//     }
//   };

//   // Render navigation items
//   const renderNavItems = () => {
//     return navigationItems.map((item) => {
//       // Special handling for Create Invoice
//       if (item.name === 'Create Invoice') {
//         return (
//           <button
//             key={item.name}
//             onClick={handleCreateInvoice}
//             className={`
//               w-full flex items-center justify-between py-3 px-4 rounded-lg transition-colors text-left
//               ${isActive(item.path)
//                 ? 'bg-red-100 text-red-700'
//                 : 'text-gray-700 hover:bg-gray-100'}
//             `}
//           >
//             <div className="flex items-center">
//               <span className="flex-shrink-0">{item.icon}</span>
//               {!isCollapsed && (
//                 <span className="ml-3 font-medium">{item.name}</span>
//               )}
//             </div>
//           </button>
//         );
//       }

//       // Regular navigation items
//       return (
//         <Link
//           key={item.name}
//           to={item.path}
//           className={`
//             flex items-center justify-between py-3 px-4 rounded-lg transition-colors
//             ${isActive(item.path)
//               ? 'bg-red-100 text-red-700'
//               : 'text-gray-700 hover:bg-gray-100'}
//           `}
//           onClick={isMobile ? onClose : undefined}
//         >
//           <div className="flex items-center">
//             <span className="flex-shrink-0">{item.icon}</span>
//             {!isCollapsed && (
//               <span className="ml-3 font-medium">{item.name}</span>
//             )}
//           </div>

//           {/* Badge for notifications */}
//           {item.badge && !isCollapsed && (
//             <span className="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-500 rounded-full">
//               {item.badge > 9 ? '9+' : item.badge}
//             </span>
//           )}

//           {/* Dot indicator when collapsed */}
//           {item.badge && isCollapsed && (
//             <span className="absolute top-2 right-2 block h-2 w-2 bg-red-500 rounded-full"></span>
//           )}
//         </Link>
//       );
//     });
//   };

//   return (
//     <aside
//       className={`
//         flex flex-col bg-white h-full
//         ${isMobile ? 'w-64' : isCollapsed ? 'w-16' : 'w-64'}
//         ${isMobile ? 'fixed inset-y-0 left-0 z-50 shadow-xl' : 'relative'}
//         transition-all duration-300
//       `}
//     >
//       {/* Sidebar Header */}
//       <div className="flex items-center justify-between p-4 border-b min-w-0">
//         {!isCollapsed && (
//           <Link to="/profile" onClick={isMobile ? onClose : undefined} className="flex items-center min-w-0 flex-1">
//             <div className="flex items-center min-w-0 flex-1">
//               <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600 flex items-center justify-center text-white font-bold text-lg overflow-hidden">
//                 {vendorProfile?.logoURL ? (
//                   <img
//                     src={vendorProfile.logoURL}
//                     alt={vendorProfile.shopName || 'Logo'}
//                     className="w-full h-full object-cover rounded-full"
//                     onError={(e) => {
//                       // Fallback to text if image fails to load
//                       e.target.style.display = 'none';
//                       e.target.nextSibling.style.display = 'flex';
//                     }}
//                   />
//                 ) : (
//                   <span>{vendorProfile?.shopName?.charAt(0) || 'Z'}</span>
//                 )}
//                 {/* Hidden fallback text element */}
//                 {vendorProfile?.logoURL && (
//                   <span style={{ display: 'none' }} className="w-full h-full flex items-center justify-center">
//                     {vendorProfile?.shopName?.charAt(0) || 'Z'}
//                   </span>
//                 )}
//               </div>
//               <div className="ml-3 min-w-0 flex-1">
//                 <h3 className="text-sm font-medium text-gray-900 truncate">
//                   {vendorProfile?.shopName || 'ZoneXVendors'}
//                 </h3>
//                 <p className="text-xs text-gray-500 truncate">
//                   {hasOrderManagement ? 'Full Vendor' : 'Inventory Only'}
//                 </p>
//               </div>
//             </div>
//           </Link>
//         )}

//         {/* Toggle collapse button (only for desktop) */}
//         {!isMobile && (
//           <button
//             className="p-1 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-500 flex-shrink-0 ml-2"
//             onClick={() => setIsCollapsed(!isCollapsed)}
//           >
//             {isCollapsed ? (
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-5 w-5"
//                 viewBox="0 0 20 20"
//                 fill="currentColor"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//             ) : (
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-5 w-5"
//                 viewBox="0 0 20 20"
//                 fill="currentColor"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//             )}
//           </button>
//         )}

//         {/* Close button (only for mobile) */}
//         {isMobile && (
//           <button
//             className="p-1 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-500 flex-shrink-0 ml-2"
//             onClick={onClose}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-6 w-6"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </button>
//         )}
//       </div>

//       {/* Collapsed Quick Action */}
//       {isCollapsed && (
//         <div className="p-2 border-b">
//           <button
//             onClick={handleCreateInvoice}
//             className="w-full flex items-center justify-center p-2 border border-transparent rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
//             title="Create Invoice"
//           >
//             <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//             </svg>
//           </button>
//         </div>
//       )}

//       {/* Navigation */}
//       <nav className="flex-1 overflow-y-auto p-4 space-y-2">
//         {renderNavItems()}
//       </nav>

//       {/* Sidebar Footer */}
//       {!isCollapsed && (
//         <div className="p-4 border-t">
//           <div className="bg-red-50 rounded-lg p-3">
//             <h4 className="text-sm font-medium text-red-800">Need Help?</h4>
//             <p className="mt-1 text-xs text-red-600">
//               Contact our support team for assistance with your vendor account.
//             </p>
//             <a
//               href="mailto:support@zonexvendors.com"
//               className="mt-2 inline-flex items-center text-xs font-medium text-red-700 hover:text-red-900"
//             >
//               Contact Support
//               <svg xmlns="http://www.w3.org/2000/svg" className="ml-1 h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
//                 <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
//               </svg>
//             </a>
//           </div>
//         </div>
//       )}
//     </aside>
//   );
// };

// export default Sidebar;
// VENDOR PROJECT - src/components/layout/Sidebar.jsx (UPDATED WITH NOTIFICATIONS)
// MINIMAL UPDATE: src/components/layout/Sidebar.jsx - Just add real-time product requests count
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useNotification } from '../../contexts/NotificationContext';
import { subscribeToProductRequestsRealTime } from '../../services/productRequestService'; // UPDATE THIS LINE
import { useRef } from 'react';
import { TruckIcon } from '@heroicons/react/24/outline';


const Sidebar = ({ isMobile = false, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { vendorProfile } = useAuth();
  const { unreadCount } = useNotification();
  const [isCollapsed, setIsCollapsed] = useState(false);
  

  const [showMoreDropdown, setShowMoreDropdown] = useState(false);
const moreRef = useRef(null);


  // ADD THESE LINES - Real-time product requests state
  const [realTimeProductRequests, setRealTimeProductRequests] = useState([]);
  const [pendingProductRequests, setPendingProductRequests] = useState(0);

  // Check if vendor has order management enabled
  const hasOrderManagement = vendorProfile?.businessType !== 'without-orders';

  // ADD THIS EFFECT - Setup real-time listener for product requests
  useEffect(() => {
    if (!vendorProfile?.uid || !hasOrderManagement) {
      setRealTimeProductRequests([]);
      setPendingProductRequests(0);
      return;
    }

    console.log('🔄 Setting up real-time product requests listener in Sidebar');
    
    const unsubscribe = subscribeToProductRequestsRealTime(vendorProfile.uid, (requests) => {
      console.log('📦 Sidebar received real-time product requests update:', requests.length);
      
      setRealTimeProductRequests(requests);
      
      // Count pending requests that aren't expired
      const now = new Date();
      const pendingCount = requests.filter(request => {
        if (request.status !== 'pending') return false;
        
        if (request.expiresAt) {
          const expiry = request.expiresAt.toDate ? request.expiresAt.toDate() : new Date(request.expiresAt);
          return now <= expiry;
        }
        return true;
      }).length;
      
      setPendingProductRequests(pendingCount);
    });

    return () => {
      console.log('🔕 Cleaning up product requests listener in Sidebar');
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [vendorProfile?.uid, hasOrderManagement]);


  useEffect(() => {
  const handleClickOutside = (event) => {
    if (moreRef.current && !moreRef.current.contains(event.target)) {
      setShowMoreDropdown(false);
    }
  };
  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);


  // Navigation items - UPDATE THIS SECTION
  const navigationItems = [
    {
      name: 'Dashboard',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      path: '/dashboard',
    },
    {
      name: 'Inventory',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      ),
      path: '/inventory',
    },
    // Only show Orders if order management is enabled - UPDATE THIS SECTION
    ...(hasOrderManagement ? [{
      name: 'Orders & Requests',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
      ),
      path: '/orders',
      badge: pendingProductRequests > 0 ? pendingProductRequests : null, // USE REAL-TIME COUNT
      badgeColor: 'bg-red-500'
    }] : []),
    ...(hasOrderManagement ? [{
      name: 'Communication',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      ),
      path: '/communication',
    }] : []),
    ...(hasOrderManagement ? [{
      name: 'Notifications',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
      ),
      path: '/notifications',
      badge: unreadCount > 0 ? unreadCount : null,
      badgeColor: 'bg-red-500'
    }] : []),
    // ...(hasOrderManagement ? [{
    //   name: 'Porter',
    //   icon: (
    //     <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    //     </svg>
    //   ),
    //   path: '/porter',
    // }] : []),
   
    {
      name: 'Billing',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
      path: '/billing',
    },
    {
      name: 'Create Invoice',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
      ),
      path: '/billing/create',
    },
    {
      name: 'Billing Reports',
      icon: (
        <svg xmlns="http://www.w3.o
rg/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      path: '/billing/reports',
    },
    {
      name: 'Returns',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
        </svg>
      ),
      path: '/returns',
    },
    {
      name: 'Customers',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
        </svg>
      ),
      path: '/customers',
    },
    {
      name: 'Suppliers',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      path: '/suppliers',
    },
    {
      name: 'Profile',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      path: '/profile',
    },
    {
      name: 'Help',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      path: '/help',
    },

   
  ];

  // Check if a link is active
const isActive = (path) => {
  // Highlight "More" button when inside any /spares-admin route
  if (location.pathname.startsWith('/spares-admin')) {
    return true;
  }
  if (path === '/billing') {
    return location.pathname === '/billing';
  }
  if (path === '/billing/create') {
    return location.pathname === '/billing/create';
  }
  return location.pathname === path || (location.pathname.startsWith(path + '/') && path !== '/billing');
};

  // Handle create invoice navigation
  const handleCreateInvoice = () => {
    navigate('/billing/create?type=sales');
    if (isMobile && onClose) {
      onClose();
    }
  };

  // Render navigation items
  const renderNavItems = () => {
    return navigationItems.map((item) => {
      if (item.name === 'Create Invoice') {
        return (
          <button
            key={item.name}
            onClick={handleCreateInvoice}
            className={`
              w-full flex items-center justify-between py-3 px-4 rounded-lg transition-colors text-left
              ${isActive(item.path)
                ? 'bg-red-100 text-red-700'
                : 'text-gray-700 hover:bg-gray-100'}
            `}
          >
            <div className="flex items-center">
              <span className="flex-shrink-0">{item.icon}</span>
              {!isCollapsed && (
                <span className="ml-3 font-medium">{item.name}</span>
              )}
            </div>
          </button>
        );
      }

      return (
        <Link
          key={item.name}
          to={item.path}
          className={`
            flex items-center justify-between py-3 px-4 rounded-lg transition-colors relative
            ${isActive(item.path)
              ? 'bg-red-100 text-red-700'
              : 'text-gray-700 hover:bg-gray-100'}
          `}
          onClick={isMobile ? onClose : undefined}
        >
          <div className="flex items-center">
            <span className="flex-shrink-0">{item.icon}</span>
            {!isCollapsed && (
              <span className="ml-3 font-medium">{item.name}</span>
            )}
          </div>

          {item.badge && !isCollapsed && (
            <span className={`inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white rounded-full ${item.badgeColor || 'bg-red-500'}`}>
              {item.badge > 9 ? '9+' : item.badge}
            </span>
          )}

          {item.badge && isCollapsed && (
            <span className={`absolute top-2 right-2 block h-2 w-2 rounded-full ${item.badgeColor || 'bg-red-500'}`}></span>
          )}
        </Link>
      );
    });
  };

  return (
    <aside
      className={`
        flex flex-col bg-white h-full
        ${isMobile ? 'w-64' : isCollapsed ? 'w-16' : 'w-64'}
        ${isMobile ? 'fixed inset-y-0 left-0 z-50 shadow-xl' : 'relative'}
        transition-all duration-300
      `}
    >
      {/* Sidebar Header */}
      <div className="flex items-center justify-between p-4 border-b min-w-0">
        {!isCollapsed && (
          <Link to="/profile" onClick={isMobile ? onClose : undefined} className="flex items-center min-w-0 flex-1">
            <div className="flex items-center min-w-0 flex-1">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600 flex items-center justify-center text-white font-bold text-lg overflow-hidden">
                {vendorProfile?.logoURL ? (
                  <img
                    src={vendorProfile.logoURL}
                    alt={vendorProfile.shopName || 'Logo'}
                    className="w-full h-full object-cover rounded-full"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : (
                  <span>{vendorProfile?.shopName?.charAt(0) || 'Z'}</span>
                )}
                {vendorProfile?.logoURL && (
                  <span style={{ display: 'none' }} className="w-full h-full flex items-center justify-center">
                    {vendorProfile?.shopName?.charAt(0) || 'Z'}
                  </span>
                )}
              </div>
              <div className="ml-3 min-w-0 flex-1">
                <h3 className="text-sm font-medium text-gray-900 truncate">
                  {vendorProfile?.shopName || 'ZoneXVendors'}
                </h3>
                <p className="text-xs text-gray-500 truncate">
                  {hasOrderManagement ? 'Full Vendor' : 'Inventory Only'}
                </p>
              </div>
            </div>
          </Link>
        )}

        {!isMobile && (
          <button
            className="p-1 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-500 flex-shrink-0 ml-2"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            {isCollapsed ? (
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            )}
          </button>
        )}

        {isMobile && (
          <button
            className="p-1 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-500 flex-shrink-0 ml-2"
            onClick={onClose}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Product Requests Alert */}
      {hasOrderManagement && pendingProductRequests > 0 && !isCollapsed && (
        <div className="mx-4 mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-yellow-800">
                {pendingProductRequests} new product request{pendingProductRequests > 1 ? 's' : ''}
              </p>
              <p className="text-xs text-yellow-700">
                From mechanics - Click Orders to review
              </p>
            </div>
          </div>
        </div>
      )}

      {isCollapsed && (
        <div className="p-2 border-b">
          <button
            onClick={handleCreateInvoice}
            className="w-full flex items-center justify-center p-2 border border-transparent rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
            title="Create Invoice"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          </button>
        </div>
      )}

      <nav className="flex-1 overflow-y-auto p-4 space-y-2">
  {renderNavItems()}

  {/* More Dropdown */}
  <div ref={moreRef} className="relative">
    <button
      onClick={() => setShowMoreDropdown(!showMoreDropdown)}
      className={`
        w-full flex items-center justify-between py-3 px-4 rounded-lg transition-colors text-left relative
        ${location.pathname.startsWith('/spares-admin')
          ? 'bg-red-100 text-red-700'
          : 'text-gray-700 hover:bg-gray-100'}
      `}
    >
      <div className="flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
        </svg>
        {!isCollapsed && <span className="ml-3 font-medium">More</span>}
      </div>
    </button>

    {showMoreDropdown && (
      <div className="absolute left-0 bottom-full mb-2 w-56 bg-white rounded-lg shadow-xl border border-gray-200 z-50">
        <div className="py-2">
          <button
            onClick={() => {
              navigate('/spares-admin/create-task');
              setShowMoreDropdown(false);
              if (isMobile) onClose();
            }}
            className="w-full text-left px-4 py-3 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            <span className="font-medium">Create Task</span>
          </button>

          <button
            onClick={() => {
              navigate('/spares-admin/products');
              setShowMoreDropdown(false);
              if (isMobile) onClose();
            }}
            className="w-full text-left px-4 py-3 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
            <span className="font-medium">Products</span>
          </button>

          <button
  onClick={() => {
    navigate('/spares-admin/tasks');
    setShowMoreDropdown(false);
    if (isMobile) onClose();
  }}
  className="w-full text-left px-4 py-3 hover:bg-gray-100 flex items-center gap-3"
>
  <TruckIcon className="h-5 w-5 text-gray-600" />
  <span className="font-medium">Deliveries</span>
</button>


          <hr className="my-1 border-gray-200" />

          <button
            onClick={() => {
              navigate('/spares-admin/dashboard');
              setShowMoreDropdown(false);
              if (isMobile) onClose();
            }}
            className="w-full text-left px-4 py-3 hover:bg-red-50 flex items-center gap-3 text-red-700"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
            </svg>
            <span className="font-medium">More</span>
          </button>
        </div>
      </div>
    )}
  </div>
</nav>

      {!isCollapsed && (
        <div className="p-4 border-t">
          <div className="bg-red-50 rounded-lg p-3">
            <h4 className="text-sm font-medium text-red-800">Need Help?</h4>
            <p className="mt-1 text-xs text-red-600">
              Contact our support team for assistance with your vendor account.
            </p>
            <a
              href="mailto:support@zonexvendors.com"
              className="mt-2 inline-flex items-center text-xs font-medium text-red-700 hover:text-red-900"
            >
              Contact Support
              <svg xmlns="http://www.w3.org/2000/svg" className="ml-1 h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;